module.exports = __webpack_public_path__ + "static/media/HeroChickenFingers.2cf976f9.jpg";